module.exports = __webpack_public_path__ + "img/np_virtual-reality_866012_000000.d7a649d6.svg";